import sleep from './sleep';

const poll = async <F extends (...args: any[]) => any>(
  pollFn: F,
  callback: (result: ReturnType<F>, forceComplete: boolean) => Promise<boolean>,
  minInterval: number = 0,
  index: number = 0,
  timeout: number = 30 * 1000,
): Promise<ReturnType<F>> => {
  const startMs = Date.now();

  const result = await pollFn(index);

  const pollAgain = await callback(result, timeout <= 0);

  if (pollAgain) {
    const elapsedMs = Date.now() - startMs;
    const waitFor = elapsedMs < minInterval ? minInterval - elapsedMs : 0;

    await sleep(waitFor);
    const elapsedMsIncludeWaiting = Date.now() - startMs;
    return poll(
      pollFn,
      callback,
      minInterval,
      index + 1,
      timeout - elapsedMsIncludeWaiting,
    );
  }
  return result;
};
export default poll;
